export interface PackStatusDto
{
    getMsisdn(): string;
    
    getActiveRRBTStatus():string;
    getActiveCRBTStatus():string;
    getRrbtServiceExpiry():string;
    getCrbtServiceExpiry():string;
    getLanguageId():string;
    getPackName():string;
}

export class PackStatusDtoImpl implements PackStatusDto
{
    private msisdn: string;
    private activeRRBTStatus: string;
    private activeCRBTStatus: string;
    private rrbtServiceExpiry: string;
    private crbtServiceExpiry: string;
    private languageId: string;
    private packName: string;

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getActiveRRBTStatus(): string 
    {
        return this.activeRRBTStatus;
    }
    setActiveRRBTStatus(activeRRBTStatus: string)
    {
        this.activeRRBTStatus = activeRRBTStatus;
    }

    getActiveCRBTStatus(): string 
    {
        return this.activeCRBTStatus;
    }
    setActiveCRBTStatus(activeCRBTStatus: string)
    {
        this.activeCRBTStatus = activeCRBTStatus;
    }

    getRrbtServiceExpiry(): string 
    {
        return this.rrbtServiceExpiry;
    }
    setRrbtServiceExpiry(rrbtServiceExpiry: string)
    {
        this.rrbtServiceExpiry = rrbtServiceExpiry;
    }

    getCrbtServiceExpiry(): string 
    {
        return this.crbtServiceExpiry;
    }
    setCrbtServiceExpiry(crbtServiceExpiry: string)
    {
        this.crbtServiceExpiry = crbtServiceExpiry;
    }

    getLanguageId(): string 
    {
        return this.languageId;
    }
    setLanguageId(languageId: string)
    {
        this.languageId = languageId;
    }

    getPackName(): string 
    {
        return this.packName;
    }
    setPackName(packName: string)
    {
        this.packName = packName;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/packstatus/packstatusdto.tsx